import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Provider } from "react-redux";
/**Pages */
import { RegisterPage } from "./pages";
/**Layouts */
import PageLayout from "./layouts/page.layout";
/**Reduxs */
import store from "./redux/store";

function App() {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<PageLayout />}>
            <Route path="/" element={<RegisterPage />}></Route>
          </Route>
        </Routes>
      </BrowserRouter>
    </Provider>
  );
}

export default App;
